<div class="flex justify-between items-start gap-x-4 flex-wrap md:flex-nowrap">
  <ng-content></ng-content>
</div>
